import { useState, useEffect } from "react";
import { Menu, X } from "lucide-react";

const LOGO_URL = "https://customer-assets.emergentagent.com/job_maine-web/artifacts/qoipmzpw_WhatsApp%20Image%202023-11-30%20at%2017.56.14_ac124f9d.jpg";

const NAV_LINKS = [
  { href: "#home", label: "Home", id: "nav-home" },
  { href: "#about", label: "About", id: "nav-about" },
  { href: "#products", label: "Products", id: "nav-products" },
  { href: "#industries", label: "Industries", id: "nav-industries" },
  { href: "#contact", label: "Contact", id: "nav-contact" },
];

export const Navbar = () => {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <nav
      data-testid="main-navbar"
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled
          ? "bg-black/85 backdrop-blur-xl border-b border-white/10"
          : "bg-transparent"
      }`}
    >
      <div className="max-w-[1400px] mx-auto px-6 md:px-12 lg:px-16 flex items-center justify-between h-20">
        <a href="#home" data-testid="navbar-logo" className="flex items-center gap-3">
          <img src={LOGO_URL} alt="Niryasa Industries" className="h-12 w-12 object-cover rounded-full border border-brand-red/40" />
          <div className="hidden sm:flex flex-col leading-tight">
            <span className="font-display text-base font-bold uppercase tracking-wider text-white">Niryasa</span>
            <span className="text-[10px] uppercase tracking-[0.3em] text-brand-red">Industries Pvt Ltd</span>
          </div>
        </a>

        <div className="hidden md:flex items-center gap-10">
          {NAV_LINKS.map((link) => (
            <a
              key={link.id}
              href={link.href}
              data-testid={link.id}
              className="text-sm uppercase tracking-[0.18em] text-white/70 hover:text-white transition-colors font-medium"
            >
              {link.label}
            </a>
          ))}
        </div>

        <a
          href="#contact"
          data-testid="navbar-cta"
          className="hidden md:inline-flex bg-brand-red text-white px-6 py-3 uppercase tracking-wider text-xs font-bold hover:bg-brand-redHover transition-colors"
        >
          Get Quote
        </a>

        <button
          data-testid="mobile-menu-toggle"
          className="md:hidden text-white p-2"
          onClick={() => setOpen(!open)}
          aria-label="Toggle menu"
        >
          {open ? <X size={24} /> : <Menu size={24} />}
        </button>
      </div>

      {open && (
        <div data-testid="mobile-menu" className="md:hidden bg-black/95 backdrop-blur-xl border-t border-white/10 px-6 py-6 flex flex-col gap-4">
          {NAV_LINKS.map((link) => (
            <a
              key={link.id}
              href={link.href}
              data-testid={`mobile-${link.id}`}
              onClick={() => setOpen(false)}
              className="text-sm uppercase tracking-[0.18em] text-white/80 hover:text-brand-red transition-colors"
            >
              {link.label}
            </a>
          ))}
          <a
            href="#contact"
            onClick={() => setOpen(false)}
            data-testid="mobile-navbar-cta"
            className="bg-brand-red text-white px-6 py-3 uppercase tracking-wider text-xs font-bold text-center mt-2"
          >
            Get Quote
          </a>
        </div>
      )}
    </nav>
  );
};
